import { Injectable } from '@angular/core';
import { CommonFunctions } from 'src/app/shared/common/common-functions';
import { FormFunctions } from '../form-functions';
import { UntypedFormGroup } from '@angular/forms';


@Injectable()
export class MultipleCheckboxCommonFunctions { 

  constructor(private commonFunctions: CommonFunctions, 
    private formFunctions: FormFunctions) {
   }
   
   disableMultipleCheckList(formGroup: UntypedFormGroup, propertyName: string, listData: any, code: string, isChecked: boolean, disable: boolean, caller?: string) { 
    let result = '';
    try {
      listData.forEach((item) => {          
        if (code != null ) {    
          if (item.code === code.trim()) {    
            item.checked = isChecked;           
            item.disabled = null;          
          } else {
            item.checked = null;           
            item.disabled = disable == true ? true : null;  
          }     
        }               
      });     

      result = this.getValues(listData);   
      formGroup.get(propertyName).setValue(result);  
    } catch(ex) { 
      console.log('[MultipleCheckboxComponent] disableMultipleCheckList  caller='+ caller +'  ex=' + ex.message);
    }     
    return result;  
  }

  updateMultipleCheckList(listData: any, code: string, isChecked: boolean) { 
    let result = '';
    try {
      listData.forEach((item) => {             
        if (code != null && item.code === code?.trim()) {            
          item.checked = isChecked == true ? true : null;          
        }         
      }); 

      result = this.getValues(listData);     
    } catch(ex) { 
      console.log('[MultipleCheckboxComponent] updateMultipleCheckList ex=' + ex.message);
    }     
    return result;  
  }

  initMultipleCheckList(listData: any, data: string, caller?: string) {
    let message ='[MultipleCheckboxComponent] initMultipleCheckList  caller='+ caller + ' data=' + data;
    try {        

      listData.forEach((item) => {    
        item.disabled = null;   
        this.updateMultipleCheckList(listData, item.code, false);
      });  

      if (data && data.length > 0) {
        const array = data.split('^');
        array.forEach((code) => {        
          this.updateMultipleCheckList(listData, code?.trim(), true);
        });  
      }
      console.log(message + ' listData=' + JSON.stringify(listData));
    } catch(ex) { 
      console.log(message + ' ex=' + ex.message);
    }     
    return listData;
  } 

  private getValues(listData: any){
    let result = '';
    try {     
      listData.forEach((item) => {          
        if (item.checked == true) {    
          if (result == '')        {
            result = item.code;        
          } else {
            result = result +  '^' + item.code;       
          }
          
        }         
      });     
    } catch(ex) { 
      console.log('[MultipleCheckboxComponent] getValues ex=' + ex.message);
    }     
    return result;  
  }
}

export interface CodeDisplayCheckedModel {
  code: string;
  display: string; 
  checked?: boolean;
  disabled?: boolean;
}

